import React from 'react'
import { WMSTileLayer } from 'react-leaflet'

// FAO GAUL administrative boundaries, served as a public OGC WMS from the FAO
// Hand-in-Hand GeoServer (CC BY 4.0 — attribution is set on the WMSTileLayer).
// Catalog (documents the L2 entry only): https://data.apps.fao.org/catalog/iso/b261410b-5e03-40e8-834f-1dab67aa2f8a
//
// The dataset has three administrative levels. The 2025 vintage publishes L1
// (regions) and L2 (provinces/districts); country outlines (L0) are only
// published in the 2024 vintage on the same endpoint, so we use that for L0.
//
// The server's default style draws thin BLACK lines that are nearly invisible
// over satellite/dark basemaps, so we override every level with an inline SLD
// (one NamedLayer per level) passed via SLD_BODY baked into the URL. Each level
// gets a distinct colour and stroke width so the hierarchy reads at a glance.
export const FAO_GAUL_LEVELS = [
  { layer: 'gaul_2024_l0', color: '#FF1E1E', width: 3.5, label: 'Country (GAUL 2024, level 0)' },
  { layer: 'gaul_2025_l1', color: '#FFA600', width: 2.5, label: 'Region (GAUL 2025, level 1)' },
  { layer: 'gaul_2025_l2', color: '#00E5FF', width: 1.5, label: 'Province / district (GAUL 2025, level 2)' },
]

const ruleFor = ({ layer, color, width }) =>
  `<NamedLayer><Name>${layer}</Name><UserStyle><FeatureTypeStyle><Rule>`
  + `<LineSymbolizer><Stroke>`
  + `<CssParameter name="stroke">${color}</CssParameter>`
  + `<CssParameter name="stroke-width">${width}</CssParameter>`
  + `</Stroke></LineSymbolizer>`
  + `</Rule></FeatureTypeStyle></UserStyle></NamedLayer>`

const SLD =
  `<StyledLayerDescriptor version="1.0.0" xmlns="http://www.opengis.net/sld">`
  + FAO_GAUL_LEVELS.map(ruleFor).join('')
  + `</StyledLayerDescriptor>`

// WMS draws layers in the order they are listed (first = bottom). Reverse so the
// finest level (L2) is drawn first and the bold country outline (L0) sits on top
// where borders coincide.
const LAYERS = [...FAO_GAUL_LEVELS].reverse().map(l => l.layer).join(',')

const FAO_GAUL_URL =
  `https://data.apps.fao.org/map/gsrv/gsrv1/gaul/wms?SLD_BODY=${encodeURIComponent(SLD)}`

function FaoGaulLayer({ opacity = 0.9 }) {
  return (
    <WMSTileLayer
      layers={LAYERS}
      styles=""
      format="image/png"
      version="1.1.1"
      transparent
      url={FAO_GAUL_URL}
      opacity={opacity}
      attribution='Admin boundaries: <a href="https://data.apps.fao.org/catalog/iso/b261410b-5e03-40e8-834f-1dab67aa2f8a" target="_blank" rel="noopener noreferrer">FAO GAUL</a> (CC BY 4.0)'
      // Throttle WMS GetMap traffic to FAO's GeoServer. These are Leaflet
      // GridLayer options forwarded by WMSTileLayer:
      //  - updateWhenIdle: only fetch tiles once panning STOPS (debounce on move)
      //  - updateWhenZooming: don't fetch mid zoom-animation
      //  - updateInterval: min ms between tile-load batches while moving
      //  - keepBuffer: fewer off-screen tiles retained/prefetched
      //  - tileSize 512: quarter as many tiles cover the same viewport
      updateWhenIdle
      updateWhenZooming={false}
      updateInterval={400}
      keepBuffer={1}
      tileSize={512}
    />
  )
}

export default FaoGaulLayer
